import * as React from 'react';
import { dialogHeadingLeftElementLogo } from 'omakase/Dialog/dialogCoreCssDefs';

import { Interpolation } from '@emotion/serialize';
import { Theme } from '@emotion/react';
import { tockLogoCore } from './tockLogoCssDefs';

type TockLogoVariant = 'default' | 'tock10';

export type TockLogoCustomProps = {
  variant?: TockLogoVariant;
  /*
   * Whether to additionally apply "header left element" styles to the component
   */
  applyLeftHeadingElementStyles?: boolean;
  id?: string;
  css?: Interpolation<Theme>;
};

export type TockLogoCoreProps = TockLogoCustomProps;

export const TockLogoCore = ({
  variant = 'default',
  applyLeftHeadingElementStyles,
  id,
  css,
  ...props
}: React.SVGProps<SVGSVGElement> & TockLogoCoreProps) => {
  const cssValue = [
    tockLogoCore,
    applyLeftHeadingElementStyles && dialogHeadingLeftElementLogo,
    css,
  ];

  switch (variant) {
    case 'default':
      return (
        <svg
          css={cssValue}
          width="86"
          height="24"
          viewBox="0 0 86 24"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M12.04 18.84C8.2388 18.84 5.16 15.7714 5.16 11.9829C5.16 8.79428 7.3616 6.10285 10.32 5.34857V0.119995C4.4892 0.942852 0 5.94857 0 12C0 18.6343 5.4008 24 12.04 24C14.7404 24 17.2344 23.1086 19.2468 21.6171L15.5316 17.9143C14.4996 18.4971 13.3128 18.84 12.04 18.84Z" />
          <path d="M18.92 11.9828C18.92 13.2514 18.576 14.4343 17.974 15.4628L21.6892 19.1657C23.2028 17.16 24.08 14.6743 24.08 11.9828C24.08 5.93142 19.5908 0.942844 13.76 0.102844V5.33142C16.7184 6.10284 18.92 8.79427 18.92 11.9828Z" />
          <path d="M38.184 21.1714C35.3116 21.1714 33.0068 19.5772 33.0068 16.2686V10.7314H30.272V7.49144H33.0068V2.89716H36.722V7.4743H40.5404V10.7143H36.722V15.5314C36.722 17.1772 37.4272 17.8286 39.0268 17.8286C39.6288 17.8286 40.1104 17.7429 40.5404 17.5886V20.8629C39.9556 21.0514 39.216 21.1714 38.184 21.1714Z" />
          <path d="M49.2952 21.2914C45.3564 21.2914 42.1572 18.1886 42.1572 14.2286C42.1572 10.2686 45.3564 7.16571 49.2952 7.16571C53.234 7.16571 56.4332 10.2686 56.4332 14.2286C56.4332 18.1886 53.234 21.2914 49.2952 21.2914ZM49.2952 17.8457C51.256 17.8457 52.6492 16.3371 52.6492 14.2457C52.6492 12.1714 51.2388 10.6457 49.2952 10.6457C47.3344 10.6457 45.9068 12.1543 45.9068 14.2457C45.9068 16.32 47.3344 17.8457 49.2952 17.8457Z" />
          <path d="M65.1364 21.2914C61.1288 21.2914 57.9468 18.3257 57.9468 14.2286C57.9468 10.1314 61.1288 7.16571 65.1364 7.16571C67.9572 7.16571 70.3996 8.74285 71.5692 11.0571L68.3356 12.7886C67.7852 11.5543 66.6328 10.6286 65.1364 10.6286C63.1756 10.6286 61.6964 12.1371 61.6964 14.2286C61.6964 16.3029 63.1928 17.8286 65.1364 17.8286C66.6328 17.8286 67.8024 16.9029 68.3356 15.6686L71.5692 17.4C70.3996 19.7314 67.9572 21.2914 65.1364 21.2914Z" />
          <path d="M80.754 13.1143L86 7.47426H85.8796H81.8892H81.6828L77.1076 12.2914V11.9828V2.94855H73.3924V21H77.1076V17.0228L78.1912 15.8743L81.8032 21H86L80.6336 13.2514L80.754 13.1143Z" />
        </svg>
      );
    case 'tock10':
      return (
        <svg
          css={cssValue}
          width="74"
          height="16"
          viewBox="0 0 74 16"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path d="M6.69802 15.2816C4.51239 15.2816 2.75866 14.0346 2.75866 11.4467V7.11557H0.677734V4.58127H2.75866V0.987671H5.58557V4.56786H8.49101V7.10216H5.58557V10.8701C5.58557 12.1573 6.12216 12.6669 7.33931 12.6669C7.79737 12.6669 8.16383 12.5998 8.49101 12.4792V15.0403C8.04604 15.1878 7.48327 15.2816 6.69802 15.2816Z" />
          <path d="M15.1504 15.3755C12.1533 15.3755 9.71902 12.9484 9.71902 9.85096C9.71902 6.75349 12.1533 4.32647 15.1504 4.32647C18.1474 4.32647 20.5817 6.75349 20.5817 9.85096C20.5817 12.9484 18.1474 15.3755 15.1504 15.3755ZM15.1504 12.6803C16.6423 12.6803 17.7024 11.5003 17.7024 9.86437C17.7024 8.24189 16.6293 7.04849 15.1504 7.04849C13.6584 7.04849 12.5721 8.22848 12.5721 9.86437C12.5721 11.4869 13.6584 12.6803 15.1504 12.6803Z" />
          <path d="M27.2054 15.3755C24.156 15.3755 21.7348 13.0557 21.7348 9.85096C21.7348 6.64622 24.156 4.32647 27.2054 4.32647C29.3518 4.32647 31.2102 5.56009 32.1002 7.3703L29.6397 8.72461C29.2209 7.75916 28.3441 7.03508 27.2054 7.03508C25.7135 7.03508 24.5879 8.21507 24.5879 9.85096C24.5879 11.4734 25.7266 12.6668 27.2054 12.6668C28.3441 12.6668 29.234 11.9428 29.6397 10.9773L32.1002 12.3316C31.2102 14.1552 29.3518 15.3755 27.2054 15.3755Z" />
          <path d="M39.0887 8.97945L43.0804 4.5679H39.7954L36.3141 8.33582V1.02793H33.4872V15.1476H36.3141V12.0367L37.1386 11.1383L39.887 15.1476H43.0804L38.997 9.08672L39.0887 8.97945Z" />
          <path d="M66.0048 12.2687C63.7785 12.2687 61.9753 10.4212 61.9753 8.14023C61.9753 6.22048 63.2647 4.60004 64.9974 4.14591V0.997926C61.5824 1.49335 58.9531 4.50715 58.9531 8.15055C58.9531 12.1449 62.1163 15.3754 66.0048 15.3754C67.5864 15.3754 69.0471 14.8387 70.2258 13.9408L68.0498 11.7114C67.4454 12.0623 66.7503 12.2687 66.0048 12.2687Z" />
          <path d="M70.0342 8.1403C70.0342 8.90407 69.8327 9.61624 69.4801 10.2355L71.6561 12.4649C72.5426 11.2573 73.0563 9.76073 73.0563 8.1403C73.0563 4.4969 70.427 1.49341 67.012 0.987671V4.13565C68.7447 4.60011 70.0342 6.22055 70.0342 8.1403Z" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M56.0236 1.07556H53.3966L53.3681 1.18234C53.1245 2.09238 52.6863 2.75915 52.0604 3.19726L52.0528 3.20262C51.724 3.43274 51.4957 3.59261 51.2137 3.69957C50.9322 3.80635 50.5882 3.86319 50.0307 3.86319H49.8867V6.00963H52.9678V12.6017H49.8867V15.2029H58.7488V12.6017H56.0236V1.07556Z"
          />
        </svg>
      );
  }
};
